// extracted by mini-css-extract-plugin
export default {"manualBusinessButton":"Onboarding_manualBusinessButton__Edhou","navigationButton":"Onboarding_navigationButton__xiweY"};